(function () {
  'use strict';

  var container = document.querySelector('[data-quick-add-confirmation]');
  if (!container) return;

  var pendingAdds = new Map();
  var clearTimer;

  function getVariantQuantity(cart, variantId) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce(function (quantity, item) {
      return String(item.variant_id) === String(variantId) ? quantity + Number(item.quantity || 0) : quantity;
    }, 0);
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('Unable to read cart');
      return response.json();
    });
  }

  function showConfirmation(title) {
    var message = container.getAttribute('data-quick-add-prefix') || '';
    var messageElement = container.querySelector('[data-quick-add-message]');
    var toast = document.createElement('div');
    var cartUrl = container.getAttribute('data-cart-url') || '/cart';
    var cartLabel = container.getAttribute('data-view-cart-label') || '';

    toast.className = 'quick-add-confirmation';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');

    if (messageElement) {
      messageElement.textContent = title ? message + ' ' + title : message;
      toast.appendChild(messageElement.cloneNode(true));
    } else {
      toast.textContent = title ? message + ' ' + title : message;
    }

    if (cartLabel) {
      var cartLink = document.createElement('a');
      cartLink.href = cartUrl;
      cartLink.className = 'quick-add-confirmation__link';
      cartLink.textContent = cartLabel;
      toast.appendChild(cartLink);
    }

    container.querySelectorAll('.quick-add-confirmation').forEach(function (existingToast) {
      existingToast.remove();
    });
    container.classList.remove('hidden');
    container.appendChild(toast);

    clearTimeout(clearTimer);
    clearTimer = window.setTimeout(function () {
      toast.remove();
      if (!container.querySelector('.quick-add-confirmation')) container.classList.add('hidden');
    }, 4500);
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      var card = form.closest('product-card');
      var variantInput = form.querySelector('input[name="id"]');
      if (!card || !variantInput || !variantInput.value) return;

      var title = card.querySelector('.product-card__title')?.textContent?.trim() || '';
      var variantId = variantInput.value;

      getCart()
        .then(function (cart) {
          pendingAdds.set(String(variantId), {
            quantityBefore: getVariantQuantity(cart, variantId),
            title: title,
          });
        })
        .catch(function () {
          pendingAdds.delete(String(variantId));
        });
    },
    true
  );

  window.addEventListener('cart:toggle', function (event) {
    var button = event.detail && event.detail.element;
    if (!(button instanceof HTMLElement)) return;

    var card = button.closest('product-card');
    var variantInput = card?.querySelector('input[name="id"]');
    if (!card || !variantInput || !variantInput.value) return;

    var variantId = String(variantInput.value);
    var pendingAdd = pendingAdds.get(variantId);
    if (!pendingAdd) return;

    window.setTimeout(function () {
      getCart()
        .then(function (cart) {
          var quantityAfter = getVariantQuantity(cart, variantId);
          if (quantityAfter > pendingAdd.quantityBefore) showConfirmation(pendingAdd.title);
        })
        .catch(function () {
          // A confirmation is intentionally omitted when Shopify cannot confirm the cart state.
        })
        .finally(function () {
          pendingAdds.delete(variantId);
        });
    }, 100);
  });
})();
